import React from 'react'

const IconArrowUpRight = ({
  width = 12,
  height = 12,
  stroke = 'currentColor',
  responsive = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      aria-hidden="true"
      focusable="false"
      {...svgAttributes}
    >
      <path
        d="M3.07107 1.69675H10.1421M10.1421 1.69675V8.76782M10.1421 1.69675L1.53553 10.3034"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconArrowUpRight
